import Icon from '../components/Icon.vue'

Icon.register({
  equals: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 304H32C14.3 304 0 318.3 0 336V368C0 385.7 14.3 400 32 400H416C433.7 400 448 385.7 448 368V336C448 318.3 433.7 304 416 304zM416 112H32C14.3 112 0 126.3 0 144V176C0 193.7 14.3 208 32 208H416C433.7 208 448 193.7 448 176V144C448 126.3 433.7 112 416 112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/equals.js
// module id = xgoD
// module chunks = 144